import { call } from 'redux-saga/effects';
import axios from 'axios';

const Api = {
  createOrder: params =>
    axios.post('/api/order/create/wayforpay?identity=client', params)
};

function* createOrder({ payload: { params, onStart, onSuccess, onError } }) {
  onStart && onStart();

  try {
    const { status, data } = yield call(Api.createOrder, params);
    if (status === 200) {
      onSuccess && onSuccess(data);
    }
  } catch (error) {
    onError && onError(error);
  }
}

export default createOrder;
